import { useState } from "react";
import { FinanceDialog } from "../finance/FinanceDialog";
import { TeamLogoUpload } from "../events/TeamLogoUpload";
import { useLocale } from "../i18n";

export function OrganizationLogoDialog({ organization, onClose, onSaved, onReload }: {
 organization: { id: string; name: string; version: number; logoMediaId?: string; logoMedia?: {previewUrl?: string} };
 onClose: () => void; onSaved: () => void; onReload: () => void;
}) {
 const {w}=useLocale(); const [logo,setLogo]=useState(organization.logoMediaId);
 const [upload,setUpload]=useState({busy:false,blocked:false});
 return <FinanceDialog title={w("شعار المنشأة","Organization logo")} description={organization.name}
  path="/organizationManagement/logo" payload={{partyId:organization.id,expectedVersion:organization.version,logoMediaId:logo||null}}
  valid={!upload.busy&&!upload.blocked} pending={upload.busy} onClose={onClose} onSaved={onSaved} onReload={onReload}>
  <TeamLogoUpload organization uploadPath="/organizationManagement/logoUpload/" value={logo} initialPreviewUrl={organization.logoMedia?.previewUrl} onChange={setLogo} onStatusChange={setUpload}/>
 </FinanceDialog>;
}
